<template>
  <div>
    <div class="columns is-multiline">
      <div class="column" :class="fromQuickview ? 'is-12 is-padding-bottom-small': 'is-6 is-paddingless-bottom'">
        <r-label :label="label" :value="currentUserCountry === 'FRA' || !fromContact ? address.line1 && address.zip_code && address.city : address.zip_code && address.city" :redCheck="redCheck" :is-required="isRequired" :from-flux="fromFlux"></r-label>
        <div class="field has-addons">
          <p class="control">
            <a class="button is-grey is-border-top is-border-bottom is-border-left is-min-width-0 is-square is-static">
              <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
            </a>
          </p>
          <p class="control is-expanded">
            <GmapAutocomplete @place_changed="getAddressData" class="input" :bounds="userLocation"
                              :value="inlineAddress" :selectFirstOnEnter="true" :placeholder="placeholder" ref="autocomplete">
            </GmapAutocomplete>
          </p>
        </div>
      </div>
      <div class="column" v-if="!onlyInput" :class="fromQuickview ? 'is-12 is-padding-bottom-small': 'is-paddingless-bottom'">
        <label class="label" :for="`'completeAddress'+${Date.now()}`">UN PROBLÈME AVEC L'ADRESSE, SAISIR MANUELLEMENT</label>
        <div class="is-margin-top-small">
          <input :id="`'completeAddress'+${Date.now()}`" type="checkbox" :name="`'completeAddress'+${Date.now()}`"
                class="switch is-success is-rounded is-medium" v-model="completeAddress"
                 data-type-cy="switch" data-value-cy="switch_manuel_address">
          <label :for="`'completeAddress'+${Date.now()}`" class="label is-padding-top-xxsmall"><span
            class="is-size-6 has-text-grey">{{completeAddress ? 'Oui' : 'Non'}}</span></label>
        </div>
      </div>

      <transition name="animation-sans-nom" enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster">
        <div class="columns column is-12 is-multiline is-paddingless" v-if="completeAddress && !onlyInput">
          <div class="column is-12 is-paddingless-bottom" :class="{'is-6-widescreen':!fromQuickview}">
            <r-label :label="'Numéro et rue'" :value="address.line1" :from-flux="fromFlux" :is-required="currentUserCountry === 'FRA' || !fromContact"></r-label>
            <v-input :id="'line1'" :name="'line1'" @input="val => addressInput('line1', val)" :model="address.line1"
                    :errors-bag="errors" :fromFlux="fromFlux" data-vv-value-path="val"
                    data-vv-as="Numéro et rue" v-validate="currentUserCountry === 'FRA' || !fromContact ? 'required|min:2' : 'min:2'" data-type-cy="input" data-value-cy="line1_address">
            </v-input>
          </div>
          <div class="column is-12 is-paddingless-bottom" :class="{'is-6-widescreen':!fromQuickview}">
            <div class="columns is-gapless is-multiline">
              <div class="column" :class="fromQuickview ? 'is-12 is-padding-bottom-small': 'is-4 is-padding-right-small'">
                <r-label :label="'Code Postal'" :value="address.zip_code" :from-flux="fromFlux"></r-label>
                <v-input :id="'zip_code'" :name="'zip_code'" @input="val => addressInput('zip_code', val)"
                        :model="address.zip_code"
                        :errors-bag="errors" :fromFlux="fromFlux" data-vv-value-path="val"
                        data-vv-as="Code Postal" v-validate="'required|numeric'" data-type-cy="input" data-value-cy="zip_code_address">
                </v-input>
              </div>
              <div class="column" :class="fromQuickview ? 'is-12 is-padding-bottom-small': 'is-5 is-padding-right-small'">
                <r-label :label="'Ville'" :value="address.city" :from-flux="fromFlux"></r-label>
                <v-input :id="'city'" :name="'city'" @input="val => addressInput('city', val)" :model="address.city"
                         :errors-bag="errors" :fromFlux="fromFlux" data-vv-value-path="val"
                        data-vv-as="Ville" v-validate="'required|min:2'" data-type-cy="input" data-value-cy="city_address">
                </v-input>
              </div>
              <div class="column" :class="fromQuickview ? 'is-12 is-padding-bottom-small': 'is-3'">
                <v-input :id="'country'" :name="'country'" @input="val => addressInput('country', val)" :model="address.country"
                        label="Pays" :errors-bag="errors" data-vv-value-path="val" :fromFlux="fromFlux"
                        data-vv-as="Pays" v-validate="'min:2'" data-type-cy="input" data-value-cy="country_address">
                </v-input>
              </div>
            </div>
          </div>

          <div v-if="geoAddress" class="column is-6">
            <v-input :id="'latitude'" :name="'latitude'" @input="updateLatitude"
                    :model="latitude" :fromFlux="fromFlux"
                    label="Latitude" :errors-bag="errors" data-vv-value-path="val"
                    data-vv-as="Latitude" v-validate="'min:1'" data-type-cy="input" data-value-cy="latitude_address">
            </v-input>
          </div>
          <div v-if="geoAddress" class="column is-6">
            <v-input :id="'longitude'" :name="'longitude'" @input="updateLongitude"
                    :model="longitude" :fromFlux="fromFlux"
                    label="Longitude" :errors-bag="errors" data-vv-value-path="val"
                    data-vv-as="Longitude" v-validate="'min:1'" data-type-cy="input" data-value-cy="longitude_address">
            </v-input>
          </div>
        </div>
      </transition>
    </div>
    <span v-if="errorMess"></span>
  </div>
</template>

<script>
  import { isNil, isEmpty, isPlainObject } from 'lodash'
  import { gmapApi } from 'vue2-google-maps'
  import { mapGetters } from 'vuex'

  const emptyAddress = {
    line1: null,
    line2: null,
    country: null,
    state: null,
    zip_code: null,
    city: null
  }

  export default {
    name: 'GmapInput',
    props: {
      redCheck: Boolean,
      source: {
        type: [Object, String],
        required: false
      },
      label: {
        type: String,
        default: 'Adresse'
      },
      geoAddress: {
        type: Boolean,
        default: false
      },
      fromContact: {
        type: Boolean,
        default: false
      },
      geoSource: {
        type: Object,
        required: false
      },
      onlyInput: {
        type: Boolean,
        default: false
      },
      clearAfterSubmit: {
        type: Boolean,
        default: false
      },
      isRequired: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      fromQuickview: {
        type: Boolean,
        default: false
      },
      fromFlux: Boolean
    },
    components: {},
    data () {
      return {
        hasValue: false,
        address: {},
        completeAddress: false,
        longitude: null,
        latitude: null,
        inlineAddress: null,
        isEmpty
      }
    },
    watch: {
      source () {
        return this.init()
      }
    },
    computed: {
      ...mapGetters(['currentUserCountry']),
      errorMess () {
        let isError = this.errors.any()
        this.$emit('errorMess', isError)
        return isError
      },
      noZipCode () {
        return isNil(this.address.zip_code) || this.address.zip_code.length < 5
      },
      noNumeroRue () {
        return isNil(this.address.line1) || this.address.line1.length < 5
      },
      noCity () {
        return isNil(this.address.city) || this.address.city.length < 2 || this.address.city === ''
      },
      google () {
        if (gmapApi && gmapApi()) {
          return gmapApi()
        }
      },
      userLocation () {
        if (localStorage.getItem('userLocation') && this.google) {
          return new this.google.maps.LatLngBounds(JSON.parse(localStorage.getItem('userLocation')))
        }
      }
    },
    methods: {
      sendData () {
        this.$emit('submit', {address: this.address, location: {longitude: this.longitude, latitude: this.latitude}})
        if (this.clearAfterSubmit && !this.noZipCode && !this.noNumeroRue && !this.noCity) {
          this.$refs.autocomplete.$el.value = null
          this.hasValue = false
          this.$set(this, 'address', Object.assign({}, emptyAddress))
          this.$set(this, 'inlineAddress', null)
        }
      },
      addressInput (field, value) {
        this.hasValue = true
        this.$set(this.address, field, value)
        this.$emit('submit', {address: this.address, location: {longitude: this.longitude, latitude: this.latitude}})
      },
      processAddress (geoAddress) {
        let entries = ['line1', 'zip_code', 'city', 'country']
        let inlineAddress = []

        entries.forEach(x => {
          if (!isNil(geoAddress[x]) && geoAddress[x] !== '') {
            inlineAddress.push(geoAddress[x])
          }
        })
        if (inlineAddress.length > 0) {
          return inlineAddress.join(' ')
        } else {
          return null
        }
      },
      getAddressData (value) {
        this.errors.clear()
        this.hasValue = true
        let newAddress = {}
        if (!value.address_components) return
        value.address_components.forEach((el, idx) => {
          newAddress[el.types[0]] = el.long_name
        })
        this.latitude = value.geometry.location.lat()
        this.longitude = value.geometry.location.lng()

        this.$set(this.address, 'country', newAddress.country)
        this.$set(this.address, 'city', newAddress.locality)
        this.$set(this.address, 'line1', newAddress.street_number ? newAddress.street_number.concat(' ' + newAddress.route) : newAddress.route)
        this.$set(this.address, 'state', newAddress.administrative_area_level_2 || newAddress.administrative_area_level_1)
        this.$set(this.address, 'zip_code', newAddress.postal_code)
        this.sendData()
      },
      updateLatitude (val) {
        this.latitude = parseFloat(val)
        this.sendData()
      },
      updateLongitude (val) {
        this.longitude = parseFloat(val)
        this.sendData()
      },
      getCurrentLocation () {
        if (!localStorage.getItem('userLocation')) {
          if ('geolocation' in navigator) return navigator.geolocation.getCurrentPosition(this.getGoogleMaps)
        }
      },
      getGoogleMaps (position) {
        localStorage.setItem('userLocation', JSON.stringify({lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude)}))
      },
      init () {
        if (!isNil(this.source) && !isEmpty(this.source)) {
          if (isPlainObject(this.source)) {
            this.inlineAddress = this.processAddress(this.source)
            this.address = Object.assign({}, this.source)
            if (this.geoSource && this.geoAddress) {
              this.longitude = this.geoSource.longitude ? parseFloat(this.geoSource.longitude) : null
              this.latitude = this.geoSource.latitude ? parseFloat(this.geoSource.latitude) : null
            }
          } else this.inlineAddress = this.source.slice()
        } else {
          this.address = Object.assign({}, emptyAddress)
          this.inlineAddress = null
          this.longitude = null
          this.latitude = null
        }
      }
    },
    created () {
      this.getCurrentLocation()
      this.init()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/utils/GmapInput.vue